import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.BusinessBankStatementsTrueLayer.title',
        defaultMessage: 'Link my bank account'
    },
    cta: {
        id: '_.BusinessBankStatementsTrueLayer.cta',
        defaultMessage: 'Link bank account'
    },
    ctaShareBankData: {
        id: '_.BusinessBankStatementsTrueLayer.ctaShareBankData',
        defaultMessage: 'Share bank data'
    },
    trueLayerSuccess: {
        id: '_.BusinessBankStatementsTrueLayer.success',
        defaultMessage: 'Your bank account has been linked successfully!'
    },
    trueLayerNoPermission: {
        id: '_.BusinessBankStatementsTrueLayer.no_permission',
        defaultMessage: 'We didn’t get your permission to link your account.'
    },
    trueLayererror: {
        id: '_.BusinessBankStatementsTrueLayer.error',
        defaultMessage:
            'Something went wrong while linking your bank account. Try again.'
    }
});
